export const UPDATE_SLIDER_REQUEST = 'UPDATE_SLIDER_REQUEST';
export const UPDATE_SLIDER_SUCCESS = 'UPDATE_SLIDER_SUCCESS';
export const UPDATE_SLIDER_FAIL = 'UPDATE_SLIDER_FAIL';